import {
  ArticleHeaderSVG,
  FolderHollowSVG,
  PaperHollowSVG,
  PowerWordFilledSVG,
  VideoSVG,
  SpanishFilledSVG,
  SubjectScienceSVG,
  type SvgComponentType,
} from "@newsela/angelou";

import FormativeIcon from "@/icons/FormativeLogoIcon";
import DecodableFilledIcon from "@/icons/DecodableFilledIcon";

export const LangstonParameterSchema = {
  article_type: {
    key: "article_type",
  },
  concepts: {
    key: "concepts",
  },
  content_types: {
    key: "content_types",
    values: [
      {
        label: "Articles",
        value: "ARTICLE",
        SvgComponent: ArticleHeaderSVG as SvgComponentType,
      },
      {
        label: "Videos",
        value: "INTERACTIVE_VIDEO&GENERATION_GENIUS_VIDEO",
        SvgComponent: VideoSVG as SvgComponentType,
      },
      {
        label: "Text Sets",
        value: "BUNDLE",
        SvgComponent: FolderHollowSVG as SvgComponentType,
      },
      {
        label: "PhET Simulations",
        value: "PHET_SIMULATION",
        SvgComponent: SubjectScienceSVG as SvgComponentType,
      },
      {
        label: "Worksheets",
        value: "WORKSHEET",
        SvgComponent: PaperHollowSVG as SvgComponentType,
      },
    ],
  },
  grade_levels: {
    key: "grade_levels",
    values: [
      {
        label: "K",
        value: "0",
      },
      {
        label: "1st",
        value: "1",
      },
      {
        label: "2nd",
        value: "2",
      },
      {
        label: "3rd",
        value: "3",
      },
      {
        label: "4th",
        value: "4",
      },
      {
        label: "5th",
        value: "5",
      },
      {
        label: "6th",
        value: "6",
      },
      {
        label: "7th",
        value: "7",
      },
      {
        label: "8th",
        value: "8",
      },
      {
        label: "9th",
        value: "9",
      },
      {
        label: "10th",
        value: "10",
      },
      {
        label: "11th",
        value: "11",
      },
      {
        label: "12th",
        value: "12",
      },
    ],
  },
  instructional_features: {
    key: "instructional_features",
    values: [
      {
        label: "Decodables",
        value: "decodable",
        dataQaSelector: "filter-search-by-decodables-feature",
        SvgComponent: DecodableFilledIcon as SvgComponentType,
      },
      {
        label: "Power Words",
        value: "power_words",
        dataQaSelector: "filter-search-by-power-words-instructional-feature",
        SvgComponent: PowerWordFilledSVG as SvgComponentType,
      },
      {
        label: "Formatives by Newsela",
        value: "formative",
        dataQaSelector: "filter-search-by-formative-instructional-feature",
        SvgComponent: FormativeIcon as SvgComponentType,
        overrideStyles: {
          svg: { width: "18px", marginRight: "10px" },
        },
      },
      {
        label: "Spanish",
        paramName: "languages",
        value: "LANG_ES",
        dataQaSelector: "filter-search-by-spanish",
        SvgComponent: SpanishFilledSVG as SvgComponentType,
        overrideStyles: {
          svg: { width: "22px", marginRight: "8px" },
        },
      },
    ],
  },
  needle: {
    key: "needle",
  },
  prompt: {
    key: "prompt",
  },
  languages: {
    key: "languages",
    default: "LANG_EN",
    values: [
      {
        label: "English",
        value: "LANG_EN",
      },
      {
        label: "Spanish",
        value: "LANG_ES",
      },
    ],
  },
  minimum_maturity: {
    key: "minimum_maturity",
  },
  maximum_maturity: {
    key: "maximum_maturity",
  },
  page: {
    key: "page",
    default: "0",
  },
  page_size: {
    key: "page_size",
  },
  reading_skills: {
    key: "reading_skills",
  },
  sort: {
    key: "sort",
    default: "score",
    values: [
      {
        label: "Most Recent",
        value: "-date_published",
      },
      {
        label: "Most Relevant",
        value: "score",
      },
    ],
  },
  standards: {
    key: "standards",
  },
  strategy: {
    key: "strategy",
  },
  streams: {
    key: "streams",
  },
  topics: {
    key: "topics",
  },
  visibility_parameters: {
    key: "visibility_parameters",
  },
};

type GradeLabelToValue = { [key: string]: string };

/**
 * An object whose keys are the grade level labels, and values are the grade
 * search values (string numbers).
 */
export const gradeLabelToValue =
  LangstonParameterSchema.grade_levels.values.reduce(
    (accObj, { label, value }) => {
      accObj[label] = value;
      return accObj;
    },
    {} as GradeLabelToValue,
  );
